import { render, staticRenderFns } from "./MyComment.vue?vue&type=template&id=6b92cf36&"
import script from "./MyComment.vue?vue&type=script&lang=ts&"
export * from "./MyComment.vue?vue&type=script&lang=ts&"
import style0 from "./MyComment.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports